<template>
  <div id="projectLists">
    <el-row class="header-row">
      <el-col :span="16">
        <h3 class="el-page-header">My Projects</h3>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>
            <clientNavSelector></clientNavSelector>
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: `/${currentClientId}/my-projects` }">My Projects</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="8">
        <rebuttalTraining style="float: right;"></rebuttalTraining>
      </el-col>
    </el-row>
    <div v-loading="loading" v-if="loading" element-loading-spinner="nucleus-loader"></div>
    <div v-if="!loading">
      <div>
        <el-row>
          <el-col :lg="24" :md="24" :sm="24">
            <div style="display: flex" class="pull-right">
              <div v-if="rebuttalManager()">
                <el-button @click="showManageUsersModal = true" style="margin-right: 10px;">Manage Users</el-button>
              </div>
              <div style="display: grid; grid-template-columns: auto auto">
                <el-date-picker class="hiaRangePicker" size="mini" format="MM/dd/yyyy" value-format="MM/dd/yyyy" v-model="localdateRange" type="daterange" range-separator="To" start-placeholder="Start date" end-placeholder="End date" @change="handleCriteriaChange" style="z-index: 1;" :picker-options="dateRangePickerConfig" clearable> </el-date-picker>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row :span="24" style="margin-top: 20px;">
        <el-col :span="24">
          <coderReviewList v-if="selectedView === 'All Project Types'"></coderReviewList>
        </el-col>
      </el-row>
    </div>
    <div id="dialogs">
      <RebuttalUserAdminModal v-if="showManageUsersModal" :showModal="showManageUsersModal" @close="showManageUsersModal = false"></RebuttalUserAdminModal>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import coderReviewList from '@/views/MyProjects/coderReviewList'
import dateHelper from '@/mixins/date-helper'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import RebuttalUserAdminModal from '@/views/UserAdmin/RebuttalUserAdminModal.vue'
import rebuttalTraining from '@/views/MyProjects/rebuttalTraining.vue'

export default {
  name: 'coderProjectList',
  mixins: [dateHelper, HiaAuthorization],
  data() {
    return {
      rebuttalTrainingModal: false,
      activeName: 'list',
      selectedView: 'All Project Types',
      selectedCodeType: 'All Code Types',
      selectedDisplayProcess: 'All Processes',
      selectedProcess: null,
      loading: false,
      dropdownsNeeded: ['codeTypes', 'projectStatus', 'projectProcesses'],
      localdateRange: [],
      showManageUsersModal: false
    }
  },
  methods: {
    ...mapActions('myProjects/', ['LOAD_PROJECT_LIST', 'LOAD_PRO_ADVANCED_LIST', 'LOAD_IP_ADVANCED_LIST', 'LOAD_OP_ADVANCED_LIST']),
    ...mapMutations('myProjects/', ['SET_SHOW_ADD_PROJECT_FORM']),
    ...mapMutations('globals/', ['SET_DATERANGE']),
    ...mapActions('dropdowns/', ['GET_DROPDOWNS']),
    async initialize() {
      try {
        this.loading = true
        await Promise.all([this.setProjectView(this.selectedView, this.selectedCodeType)])
        this.setSelectedProcess()
        this.loading = false
      } catch (e) {
        // show error message
        this.loading = false
        console.log(e)
      }
    },
    setSelectedProcess() {
      if (this.selectedDisplayProcess === 'All Processes') {
        this.selectedProcess = null
      } else {
        const listRow = this.dropdowns.projectProcesses.list.find(x => x.value === this.selectedDisplayProcess)
        if (listRow) {
          this.selectedProcess = listRow.key
        }
      }
      this.setLocalStorageProfile()
    },
    async setProjectView(view, codeType) {
      try {
        switch (view) {
          case 'All Project Types':
            await this.LOAD_PROJECT_LIST({ dateRange: this.GET_DATERANGE() })
            this.selectedView = view
            break
          case 'Professional Fee':
            await this.LOAD_PRO_ADVANCED_LIST({ dateRange: this.GET_DATERANGE(), codeType: codeType })
            // need to destroy and readd the table as we have dynamic columns for project tasks
            this.selectedView = null
            await this.$nextTick
            this.selectedView = 'Professional Fee'
            break
          case 'Outpatient':
            await this.LOAD_OP_ADVANCED_LIST({ dateRange: this.GET_DATERANGE(), codeType: codeType, opProjectType: 1003 })
            this.selectedView = null
            await this.$nextTick
            this.selectedView = 'Outpatient'
            break
          case 'Ambulatory':
            await this.LOAD_OP_ADVANCED_LIST({ dateRange: this.GET_DATERANGE(), codeType: codeType, opProjectType: 1004 })
            this.selectedView = null
            await this.$nextTick
            this.selectedView = 'Ambulatory'
            break
          case 'Inpatient':
            await this.LOAD_IP_ADVANCED_LIST({ dateRange: this.GET_DATERANGE() })
            this.selectedView = null
            await this.$nextTick
            this.selectedView = 'Inpatient'
            break
        }
        this.setLocalStorageProfile()
        this.loading = false
      } catch (e) {
        console.log(e)
        this.$message({
          message: 'Error Getting Project List',
          type: 'error'
        })
      }
    },
    getAdvancedViewOptions() {
      const options = ['All Project Types']
      options.push('Inpatient')
      options.push('Outpatient')
      options.push('Professional Fee')
      options.push('Ambulatory')
      return options
    },
    getCodeTypes() {
      const list = this.dropdowns.codeTypes.list.map(x => {
        return {
          key: x.value,
          value: x.value
        }
      })
      list.unshift({ key: 'All Code Types', value: 'All Code Types' })

      return list
    },
    getProcesses() {
      const list = this.dropdowns.projectProcesses.list.map(x => {
        return {
          key: x.value,
          value: x.value
        }
      })
      list.unshift({ key: 'All Processes', value: 'All Processes' })

      return list
    },
    setLocalStorageProfile() {
      const profileStr = window.localStorage.getItem('atomAuditProfile')
      const profile = JSON.parse(profileStr) || {}
      profile.defaultProjectList = this.selectedView
      profile.defaultCodeType = this.selectedCodeType
      profile.defaultProcess = this.selectedDisplayProcess
      window.localStorage.setItem('atomAuditProfile', JSON.stringify(profile))
    },
    triggerShowAddProjectForm() {
      this.SET_SHOW_ADD_PROJECT_FORM(true)
    },
    handleCriteriaChange() {
      // this.loading = true
      this.localdateRange = this.localdateRange || []
      this.SET_DATERANGE(this.localdateRange)
      this.setProjectView(this.selectedView, this.selectedCodeType)
    }
  },
  created: function() {
    this.localdateRange = this.newDateRange(-90, 30)
    this.SET_DATERANGE(this.localdateRange)
  },
  activated: async function() {
    const profileStr = window.localStorage.getItem('atomAuditProfile')
    const profile = JSON.parse(profileStr)

    if (profile && profile.defaultProjectList) {
      this.selectedView = profile.defaultProjectList || 'All Project Types'
      this.selectedCodeType = profile.defaultCodeType || 'All Code Types'
      this.selectedDisplayProcess = profile.defaultProcess || 'All Processes'
    }

    this.initialize()
  },
  components: {
    coderReviewList,
    RebuttalUserAdminModal,
    rebuttalTraining
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientName', 'currentClientId', 'clients', 'user']),
    ...mapState('myProjects/', ['newProjectID', 'projectList']),
    ...mapState('dropdowns/', ['dropdowns']),
    ...mapState('globals/', ['dateRangePickerConfig']),
    ...mapGetters('globals/', ['GET_DATERANGE'])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.projectListsTab {
  margin: 10px 0px 0px 0px;
}

>>> .statCol {
  min-width: 70px;
  max-width: 70px;
}

>>> .finImpactCol {
  min-width: 90px;
  max-width: 90px;
}
</style>
